import { post, downloadFile } from './request'

// 获取滑块图片
export const GetSliderCode = (params) => {
  return post('/system/sliderCode/create', params)
}
// 验证滑块
export const CheckSliderCode = (params) => {
  return post('/system/sliderCode/valid', params)
}
// 获取手机验证码
// export const LoginGetPhoneMa = (params) => {
//   return post('/system/mobile/valCode/create', params)
// }
export const LoginGetPhoneMa = (params) => {
  return post('/system/val/code/mobile/create', params)
}
// 登录
export const LoginAdminLogin = (params) => {
  return post('/system/login', params)
}
// 权限
export const AdminUserRole = (params) => {
  return post('/system/i/userRole/isAdmin', params)
}
// 短信登录
export const LoginNoteLogin = (params) => {
  return post('/system/mobileLogin', params)
}
// 校验手机验证码
export const valCodeValid = (params) => {
  return post('/system/mobile/valCode/valid', params)
}

// 注册
// export const RegisterUserRegister = (params) => {
//   return post('/large/userInfo/userRegister', params)
// }

// 修改密码
export const AdminUpdatePwd = (params) => {
  return post('/system/w/user/pwd/update2', params)
}

export const AdminUpdatePwds = (params) => {
  return post('/system/i/declare/user/pwd/reset', params)
}
// 找回密码
export const RegisterReset = (params) => {
  return post('/system/user/pwd/retrievePassword', params)
}
// 旧手机号 + 新手机号 + 新手机号验证码 修改手机号
export const systemPhoneRevamp = params => {
  return post('/system/i/declare/user/updatePhoneAndLoginName', params)
}
// 退出登录
export const LoginAdminLogout = (params) => {
  return post('/system/w/logout', params)
}

// 左侧菜单列表
export const AdminMenuViewTree = (params) => {
  return post('/system/w/user/viewMenu/list', params)
}
// 角色管理  增删改查
export const AdminRoleInsert = (params) => {
  return post('/system/i/role/insert', params)
}
export const AdminRoleDelete = (params) => {
  return post('/system/i/role/delete', params)
}
export const AdminRoleUpdate = (params) => {
  return post('/system/i/role/update', params)
}
export const AdminRoleList = (params) => {
  return post('/system/i/role/list', params)
}
// 目录列表
export const AdminMenuTree = (params) => {
  return post('/system/i/menu/tree', params)
}
// 角色对应目录列表
export const AdminRoleMenuIds = (params) => {
  return post('/system/i/role/menuIds', params)
}
// 修改角色对应目录列表
export const AdminRoleUpdateMenu = (params) => {
  return post('/system/i/role/updateMenu', params)
}
// 目录管理 增删改查
export const AdminMenuInsert = (params) => {
  return post('/system/i/menu/insert', params)
}
export const AdminMenuDelete = (params) => {
  return post('/system/i/menu/delete', params)
}
export const AdminMenuUpdate = (params) => {
  return post('/system/i/menu/update', params)
}
export const AdminMenuGet = (params) => {
  return post('/system/i/menu/get', params)
}
// 用户管理 增删改查
export const AdminUserBatUpdate = (params) => {
  return post('/system/i/user/login/batUpdate', params)
}
export const AdminUserList = (params) => {
  return post('/system/i/user/userList', params)
}

// 注册
export const addUser = (params) => {
  return post('/member/web/user/registered', params)
}
// 查看注册消息
export const getUser = (params) => {
  return post('/member/i/web/user/info', params)
}
// 修改
export const editUser = (params) => {
  return post('/member/i/user/profile/basis/up', params)
}
//
export const getBasis = (params) => {
  return post('/member/i/user/profile/unit/basis', params)
}
// 上传文件 token
export const Uploadimg = (params, paramsA) => {
  return post('/system/w/uploadFile', params, paramsA)
}
// 上传文件z
export const Uploadimgs = (params, paramsA) => {
  return post('/system/files/uploadFile', params, paramsA)
}

// 下载文件
export const AdminDownLoadFile = (params) => {
  return downloadFile('/system/w/downloadByPath', params)
}

// 文件下载 (新) 不用登陆
export const uploadFileDownload = (params) => {
  return downloadFile('/system/files/noAccessDownloadFile', params)
}

// 新注册
export const systemRegistered = (params) => {
  return post('/service/web/company/user/registered', params)
}
// 查询信息
export const systemInfo = (params) => {
  return post('/service/i/web/user/info', params)
}

// 下载初始化模板
export const systemUpdate = (params) => {
  return post('/service/stTemplateFile/get', params)
}

// 答辩模板
export const systemRespondent = (params) => {
  return downloadFile('/service/web/excel/template/respondent', params)
}
